import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class OpenTotalsSample extends Component {
    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }
    
    renderDOTNET() {
        const { storeId, apiToken, ecrNumber } = this.props;

        return (
            <pre className="sampleCode">
{`namespace Moneris
{ 
 using System;

 public class TestCanadaOpenTotals
 { 
  public static void Main(string[] args)
  { 
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string ecr_no = "`}{this.getValue(ecrNumber, "ecrNumber")}{`"; //string ecr_no = "66013455";
   string processing_country_code = "CA";

   OpenTotals opentotals = new OpenTotals();
   opentotals.SetEcrno(ecr_no);

   HttpsPostRequest mpgReq = new HttpsPostRequest();

   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(opentotals);
   mpgReq.Send();

   try
   { 
    Receipt receipt = mpgReq.GetReceipt();
    if ((receipt.GetReceiptId()).Equals("Global Error Receipt") ||
    receipt.GetReceiptId().Equals("") ||
    receipt.GetReceiptId().Equals("null"))
    { 
     Console.WriteLine("CardType = null ");
     Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
     Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
     Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
     Console.WriteLine("TransType = " + receipt.GetTransType());
     Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
     Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
     Console.WriteLine("ISO = " + receipt.GetISO());
     Console.WriteLine("BankTotals = null");
     Console.WriteLine("Message = " + receipt.GetMessage());
     Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
     Console.WriteLine("Complete = " + receipt.GetComplete());
     Console.WriteLine("TransDate = " + receipt.GetTransDate());
     Console.WriteLine("TransTime = " + receipt.GetTransTime());
     Console.WriteLine("Ticket = " + receipt.GetTicket());
     Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    } 
    else
    { 
     foreach (string ecr in receipt.GetTerminalIDs())
     { 
      Console.WriteLine("ECR: " + ecr);
    
      foreach (string cardType in receipt.GetCreditCards(ecr))
      { 
       Console.WriteLine("\\tCard Type: " + cardType);
       Console.WriteLine("\\t\\tPurchase: Count = "
       + receipt.GetPurchaseCount(ecr, cardType)
       + " Amount = "
       + receipt.GetPurchaseAmount(ecr, cardType));
    
       Console.WriteLine("\\t\\tRefund: Count = "
       + receipt.GetRefundCount(ecr, cardType)
       + " Amount = "
       + receipt.GetRefundAmount(ecr, cardType));
    
       Console.WriteLine("\\t\\tCorrection: Count = "
       + receipt.GetCorrectionCount(ecr, cardType)
       + " Amount = "
       + receipt.GetCorrectionAmount(ecr, cardType));
      }
     }
    } 
    Console.ReadLine();
   } 
   catch (Exception e)
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken, ecrNumber } = this.props;

        return (
            <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaOpenTotals
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  String ecr_no = "`}{this.getValue(ecrNumber, "ecrNumber")}{`";
  //String ecr_no = "66011091";
  String processing_country_code = "CA";

  OpenTotals opentotals = new OpenTotals();
  opentotals.setEcrno(ecr_no);

  HttpsPostRequest mpgReq = new HttpsPostRequest();

  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(opentotals);
  mpgReq.send();

  try
  { 
   Receipt receipt = mpgReq.getReceipt();
   if ((receipt.getReceiptId()).equals("Global Error Receipt") ||
   receipt.getReceiptId().equals("null") ||
   receipt.getReceiptId().equals(""))
   { 
    System.out.println("CardType = null");
    System.out.println("TransAmount = " + receipt.getTransAmount());
    System.out.println("TxnNumber = " + receipt.getTxnNumber());
    System.out.println("ReceiptId = " + receipt.getReceiptId());
    System.out.println("TransType = " + receipt.getTransType());
    System.out.println("ReferenceNum = " + receipt.getReferenceNum());
    System.out.println("ResponseCode = " + receipt.getResponseCode());
    System.out.println("ISO = " + receipt.getISO());
    System.out.println("BankTotals = null");
    System.out.println("Message = " + receipt.getMessage());
    System.out.println("AuthCode = " + receipt.getAuthCode());
    System.out.println("Complete = " + receipt.getComplete());
    System.out.println("TransDate = " + receipt.getTransDate());
    System.out.println("TransTime = " + receipt.getTransTime());
    System.out.println("Ticket = " + receipt.getTicket());
    System.out.println("TimedOut = " + receipt.getTimedOut());
   } 
   else
   { 
    for (String ecr : receipt.getTerminalIDs())
    { 
     System.out.println("ECR: " + ecr);
     
     for (String cardType : receipt.getCreditCards(ecr))
     { 
      System.out.println("\\tCard Type: " + cardType);
      System.out.println("\\t\\tPurchase: Count = "
      + receipt.getPurchaseCount(ecr, cardType)
      + " Amount = "
      + receipt.getPurchaseAmount(ecr, cardType));
    
      System.out.println("\\t\\tRefund: Count = "
      + receipt.getRefundCount(ecr, cardType)
      + " Amount = "
      + receipt.getRefundAmount(ecr, cardType));
    
      System.out.println("\\t\\tCorrection: Count = "
      + receipt.getCorrectionCount(ecr, cardType)
      + " Amount = "
      + receipt.getCorrectionAmount(ecr, cardType));
    
     }
    }
   }
  } 
  catch (Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, ecrNumber } = this.props;

        return (
            <pre className="sampleCode">
{`<?php
##
## This program takes 3 arguments from the command line:
## 1. Store id
## 2. api token
## 3. ecr number
##
## Example php -q TestOpenTotals.php store1 yesguy 66002163
##

require "../../mpgClasses.php";

$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
$ecr_number='`}{this.getValue(ecrNumber, "ecrNumber")}{`';

## step 1) create transaction array ###
$txnArray=array('type'=>'opentotals',
'ecr_number'=>$ecr_number
);
$mpgTxn = new mpgTransaction($txnArray);

## step 2) create mpgRequest object ###
$mpgReq= new mpgRequest($mpgTxn);
$mpgReq->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgReq->setTestMode(true); //false or comment out this line for production transactions

## step 3) create mpgHttpsPost object which does an https post ##
$mpgHttpPost=new mpgHttpsPost($store_id,$api_token,$mpgReq);

## step 4) get an mpgResponse object ##
$mpgResponse=$mpgHttpPost->getMpgResponse();

##step 5) get array of all credit cards
$creditCards = $mpgResponse->getCreditCards($ecr_number);

## step 6) loop through the array of credit cards and get information
for($i=0; $i < count($creditCards); $i++)
{ print "\nCard Type =
$
creditCards[$i]";
print "\\nPurchase Count = "
. $mpgResponse->getPurchaseCount($ecr_number,$creditCards[$i]);
print "\\nPurchase Amount = "
. $mpgResponse->getPurchaseAmount($ecr_number,$creditCards[$i]);
print "\\nRefund Count = "
. $mpgResponse->getRefundCount($ecr_number,$creditCards[$i]);
print "\\nRefund Amount = "
. $mpgResponse->getRefundAmount($ecr_number,$creditCards[$i]);
print "\\nCorrection Count = "
. $mpgResponse->getCorrectionCount($ecr_number,$creditCards[$i]);
print "\\nCorrection Amount = "
. $mpgResponse->getCorrectionAmount($ecr_number,$creditCards[$i]);
} ?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, ecrNumber, onEditId } = state.transactions.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, ecrNumber, onEditId, progLangId: selection };
  }
  
  export default connect(mapStateToProps, {})(OpenTotalsSample)